export default {
      id: "nav-projects-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons.svg#nav-projects",
      toString: function () {
        return this.url;
      }
    }